import React from "react";
import { useTranslation } from "react-i18next";
import "../pages/Home.css";

const PHONE_DISPLAY = "050-244-8771";
const PHONE_TEL = "+972502448771";

const ContactUs = () => {
  const { t } = useTranslation();

  return (
    <section id="contact" className="home-contact">
      <div className="home-contact__inner">
        <h2 className="home-contact__title">{t("nav.contact")}</h2>
        <p className="home-contact__sub">{t("contactHint")}</p>
        <a className="home-contact__phone" href={`tel:${PHONE_TEL}`}>
          {PHONE_DISPLAY}
        </a>
        <div className="home-contact__links">
          <button
            type="button"
            className="home-contact__btn"
            aria-label="Instagram"
            onClick={() =>
              window.open("https://www.instagram.com/dietchef93/", "_blank")
            }
          >
            <img src="/instagram.png" alt="" />
          </button>
          <button
            type="button"
            className="home-contact__btn"
            aria-label="WhatsApp"
            onClick={() =>
              window.open("https://wa.me/+972502448771", "_blank")
            }
          >
            <img src="/whatsapp.png" alt="" />
          </button>
          <button
            type="button"
            className="home-contact__btn"
            aria-label="Phone"
            onClick={() => {
              window.location.href = `tel:${PHONE_TEL}`;
            }}
          >
            <img src="/telephone.png" alt="" />
          </button>
        </div>
      </div>
    </section>
  );
};

export default ContactUs;
